// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".TextInput-module__input___W1QGH {\n  display: block;\n  width: 100%;\n  min-height: 200px;\n  padding: 16px;\n  border: 1px solid #E3DFDC;\n  border-radius: 5px;\n  font-size: 16px;\n  background-color: #ffffff;\n}\n\n.TextInput-module__textinput___FiPuc {\n  display: flex;\n  align-items: center;\n  margin-top: 2px;\n}\n\n.TextInput-module__input___W1QGH::-moz-placeholder {\n  color: #C4C2BE;\n}\n\n.TextInput-module__input___W1QGH::placeholder {\n  color: #C4C2BE;\n}\n\n\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"input": "TextInput-module__input___W1QGH",
	"textinput": "TextInput-module__textinput___FiPuc"
};
export default ___CSS_LOADER_EXPORT___;
